/**
 * Checks if the arbitrary range is within the live delay threshold.
 * @param arbitraryFromTime - The start time of the arbitrary range.
 * @param arbitraryToTime - The end time of the arbitrary range.
 * @param liveDelayThreshold - The live delay threshold.
 * @returns true if the arbitrary range is within the live delay threshold, false otherwise.
 */

export const isArbitraryRangeWithinLive = (
  arbitraryFromTime: number,
  arbitraryToTime: number,
  liveDelayThreshold: number
) => {
  return (
    arbitraryToTime >= Date.now() - liveDelayThreshold * 1000 ||
    arbitraryFromTime >= Date.now() + liveDelayThreshold * 1000
  );
};
